import axios from 'axios'

const api_consulta = axios.create({baseURL: process.env.VUE_APP_baseURLAss, withCredentials:true})

export default api_consulta